import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const MyInput = ({ type, libelle, field, options, data, setData, required }) => {


    const handleInputChange = (field, value, data, setData) => {
        let newData = { ...data };
        newData[field] = value;
        setData(newData);
    }

    // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
    return <>
        {type = "getSelect" && <InputGroup className="mb-3" key={field}>
            <InputGroup.Text>{libelle}</InputGroup.Text>
            <Form.Select
                value={data[field]}
                onChange={(e) => handleInputChange(field, e.target.value, data, setData)}
            >
                {options.map((item, index) => (
                    <option key={index} value={item}>{item}</option>
                ))}
            </Form.Select>
        </InputGroup>
        }
    </>
}

export default MyInput;
